import { createAsyncThunk } from '@reduxjs/toolkit';
import { FormalizedZipFilterRequest } from 'shared/api';
import { formalizedZipApi } from '../../api/formalizedZipApi';
import { FormalizedZipRequest } from '../types/types';

export const getAllFormalizedZips = createAsyncThunk(
  'formalizedZip/getAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await formalizedZipApi.getFormalizedZips();
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const filterFormalizedZips = createAsyncThunk(
  'formalizedZip/filter',
  async (filter: FormalizedZipFilterRequest, { rejectWithValue }) => {
    try {
      const response = await formalizedZipApi.filterFormalizedZips(filter);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getFormalizedZipById = createAsyncThunk(
  'formalizedZip/getById',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await formalizedZipApi.getFormalizedZipById(id);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const createFormalizedZip = createAsyncThunk(
  'formalizedZip/create',
  async (data: FormalizedZipRequest, { rejectWithValue }) => {
    try {
      const response = await formalizedZipApi.createFormalizedZip(data);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const updateFormalizedZip = createAsyncThunk(
  'formalizedZip/update',
  async ({ id, data }: { id: number; data: FormalizedZipRequest }, { rejectWithValue }) => {
    try {
      const response = await formalizedZipApi.updateFormalizedZip(id, data);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const deleteFormalizedZip = createAsyncThunk(
  'formalizedZip/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      await formalizedZipApi.deleteFormalizedZip(id);
      return id;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
